// Traducciones locales del módulo Canales V2
// Categorías de negocio (mismas claves en backend; el label se traduce por idioma).
// La clave (key) se guarda tal cual en BD.
export const BUSINESS_CATEGORIES = [
    'food', 'tech', 'fashion', 'sports', 'travel',
    'art', 'music', 'education', 'health', 'business',
    'entertainment', 'news', 'photography', 'games', 'other'
];

const dict = {
    es: {
        title: 'Latidos', beta: 'Beta',
        categoryLabels: {
            food: '🍽️ Comida', tech: '💻 Tecnología', fashion: '👗 Moda',
            sports: '⚽ Deportes', travel: '✈️ Viajes', art: '🎨 Arte',
            music: '🎵 Música', education: '📚 Educación', health: '🏥 Salud',
            business: '💼 Negocios', entertainment: '🎬 Entretenimiento',
            news: '📰 Noticias', photography: '📸 Fotografía', games: '🎮 Juegos',
            other: '🔖 Otro'
        },
        selectCategory: '-- Seleccionar categoría --',
        viewProfile: 'Ver perfil', subscribeCta: 'Seguir', visPrivate: 'Privado',
        alreadySubscribed: 'Siguiendo', owner: 'Creador',
        tabHome: 'Latido', tabList: 'Mis latidos',
        ownBadge: 'Tu canal',
        fameTitle: 'Latido de la Fama',
        filterFollowing: 'Siguiendo', filterOwn: 'Mis latidos',
        followers: 'Seguidores',
        emptyFollowers: 'Aún no tienes seguidores.',
        followsNChannels: 'Sigue', ofYourChannels: 'de tus canales',
        followsYou: 'Te sigue',
        emptyOwn: 'Aún no has publicado latidos.',
        inviteFollowers: 'Invitar a seguir',
        empty: 'Aún no sigues ningún latido.',
        emptyFeed: 'Tu latido está vacío. Suscríbete a alguno.',
        noMessages: 'Sin mensajes.',
        loading: 'Cargando...',
        createBtn: 'Crear latido', subscribeBtn: 'Seguir',
        chooseType: '¿Qué tipo de latido quieres?',
        typePersonal: '👋 Personal',
        typePersonalDesc: 'Para amigos, familia y contenido privado',
        typeBusiness: '🏪 Negocio',
        typeBusinessDesc: 'Para clientes, tienda o marca',
        name: 'Nombre', description: 'Descripción',
        category: 'Categoría', bio: 'Biografía', links: 'Enlaces (uno por línea)',
        isPublic: 'Canal público (descubrible)',
        inviteCode: 'Código de invitación',
        publish: 'Publicar', publishPlaceholder: 'Añade tu latido…',
        visibility: 'Visibilidad',
        visPublic: '🌐 Público', visSubscribers: '👥 Suscriptores',
        subscribers: 'suscriptores', code: 'Código', copyLink: 'Copiar link',
        leave: 'Salir del latido', delete: 'Eliminar latido',
        confirmLeave: '¿Salir de este latido?',
        confirmDelete: '¿Eliminar este latido? Esta acción no se puede deshacer.',
        back: 'Atrás', close: 'Cerrar', next: 'Siguiente', create: 'Crear', save: 'Guardar',
        attachImage: 'Imagen',
        onlyAdminsCanPost: 'Solo los administradores pueden publicar.',
        channelByLabel: 'en',
        contactMode: 'Contacto',
        contactNone: 'Ninguno',
        contactDirect: 'Chat directo',
        contactForm: 'Formulario',
        contactBoth: 'Ambos',
        useChannelDefault: 'Por defecto del canal',
        chatWithAdmin: 'Chatear con admin',
        sendInquiry: 'Información',
        inquiryTitle: 'Consulta sobre anuncio',
        inquiryAd: 'Anuncio',
        inquiryPhone: 'Teléfono',
        inquiryName: 'Nombre',
        inquiryMessage: 'Tu consulta',
        inquirySend: 'Enviar',
        inquirySent: 'Consulta enviada',
        inquiryEmail: 'Correo electrónico',
        optional: 'opcional',
        status: 'Estado', statusPlaceholder: 'Ej: Abierto, En vacaciones...',
        comments: 'Comentarios', commentsOn: 'Comentarios activados', commentsOff: 'Sin comentarios',
        addComment: 'Escribe un comentario...', sendComment: 'Enviar',
        noComments: 'Sin comentarios aún.', viewComments: 'Ver comentarios',
        react: 'Reaccionar',
        reportPost: 'Denunciar publicación', moreOptions: 'Más opciones'
    },
    en: {
        title: 'Channels', beta: 'Beta',
        categoryLabels: {
            food: '🍽️ Food', tech: '💻 Tech', fashion: '👗 Fashion',
            sports: '⚽ Sports', travel: '✈️ Travel', art: '🎨 Art',
            music: '🎵 Music', education: '📚 Education', health: '🏥 Health',
            business: '💼 Business', entertainment: '🎬 Entertainment',
            news: '📰 News', photography: '📸 Photography', games: '🎮 Games',
            other: '🔖 Other'
        },
        selectCategory: '-- Select category --',
        viewProfile: 'View profile', subscribeCta: 'Follow', visPrivate: 'Private',
        alreadySubscribed: 'Following', owner: 'Creator',
        tabHome: 'Heartbeat', tabList: 'My heartbeats',
        ownBadge: 'Your channel',
        fameTitle: 'Heartbeat of Fame',
        filterFollowing: 'Following', filterOwn: 'My heartbeats',
        followers: 'Followers',
        emptyFollowers: 'You have no followers yet.',
        followsNChannels: 'Follows', ofYourChannels: 'of your channels',
        followsYou: 'Follows you',
        emptyOwn: 'You have not posted any heartbeats yet.',
        inviteFollowers: 'Invite to follow',
        empty: "You don't follow any heartbeat yet.",
        emptyFeed: 'Your heartbeat is empty. Subscribe to one.',
        noMessages: 'No messages.',
        loading: 'Loading...',
        createBtn: 'Create heartbeat', subscribeBtn: 'Follow',
        chooseType: 'What type of heartbeat?',
        typePersonal: '👋 Personal',
        typePersonalDesc: 'For friends, family and private content',
        typeBusiness: '🏪 Business',
        typeBusinessDesc: 'For customers, shop or brand',
        name: 'Name', description: 'Description',
        category: 'Category', bio: 'Bio', links: 'Links (one per line)',
        isPublic: 'Public channel (discoverable)',
        inviteCode: 'Invite code',
        publish: 'Publish', publishPlaceholder: 'Add your heartbeat…',
        visibility: 'Visibility',
        visPublic: '🌐 Public', visSubscribers: '👥 Subscribers',
        subscribers: 'subscribers', code: 'Code', copyLink: 'Copy link',
        leave: 'Leave heartbeat', delete: 'Delete heartbeat',
        confirmLeave: 'Leave this heartbeat?',
        confirmDelete: 'Delete this heartbeat? This cannot be undone.',
        back: 'Back', close: 'Close', next: 'Next', create: 'Create', save: 'Save',
        attachImage: 'Image',
        onlyAdminsCanPost: 'Only admins can post.',
        channelByLabel: 'in',
        contactMode: 'Contact',
        contactNone: 'None',
        contactDirect: 'Direct chat',
        contactForm: 'Form',
        contactBoth: 'Both',
        useChannelDefault: 'Channel default',
        chatWithAdmin: 'Chat with admin',
        sendInquiry: 'Information',
        inquiryTitle: 'Inquiry about announcement',
        inquiryAd: 'Announcement',
        inquiryPhone: 'Phone',
        inquiryName: 'Name',
        inquiryMessage: 'Your inquiry',
        inquirySend: 'Send',
        inquirySent: 'Inquiry sent',
        inquiryEmail: 'Email',
        optional: 'optional',
        status: 'Status', statusPlaceholder: 'e.g. Open, On holiday...',
        comments: 'Comments', commentsOn: 'Comments enabled', commentsOff: 'No comments',
        addComment: 'Write a comment...', sendComment: 'Send',
        noComments: 'No comments yet.', viewComments: 'View comments',
        react: 'React',
        reportPost: 'Report post', moreOptions: 'More options'
    },
    eu: {
        title: 'Kanalak', beta: 'Beta',
        categoryLabels: {
            food: '🍽️ Janaria', tech: '💻 Teknologia', fashion: '👗 Moda',
            sports: '⚽ Kirolak', travel: '✈️ Bidaiak', art: '🎨 Artea',
            music: '🎵 Musika', education: '📚 Hezkuntza', health: '🏥 Osasuna',
            business: '💼 Negozioak', entertainment: '🎬 Aisialdia',
            news: '📰 Berriak', photography: '📸 Argazkigintza', games: '🎮 Jokoak',
            other: '🔖 Beste bat'
        },
        selectCategory: '-- Aukeratu kategoria --',
        tabHome: 'Taupada', tabList: 'Nire taupadak',
        ownBadge: 'Zure kanala',
        fameTitle: 'Famaren Taupada',
        filterFollowing: 'Jarraitzen', filterOwn: 'Nire taupadak',
        followers: 'Jarraitzaileak',
        emptyFollowers: 'Oraindik ez duzu jarraitzailerik.',
        followsNChannels: 'Jarraitzen ditu', ofYourChannels: 'zure kanaletatik',
        followsYou: 'Jarraitzen zaitu',
        emptyOwn: 'Ez duzu taupadarik argitaratu oraindik.',
        inviteFollowers: 'Jarraitzera gonbidatu',
        empty: 'Oraindik ez duzu taupadarik jarraitzen.',
        emptyFeed: 'Zure taupada hutsik dago. Harpidetu batera.',
        noMessages: 'Mezurik ez.',
        loading: 'Kargatzen...',
        createBtn: 'Sortu kanala', subscribeBtn: 'Jarraitu',
        chooseType: 'Zer motatako kanala?',
        typePersonal: 'Pertsonala',
        typePersonalDesc: 'Lagun, familia eta eduki pribaturako',
        typeBusiness: 'Negozioa',
        typeBusinessDesc: 'Bezero, denda edo markarako',
        name: 'Izena', description: 'Deskribapena',
        category: 'Kategoria', bio: 'Biografia', links: 'Estekak (bana lerroko)',
        isPublic: 'Kanal publikoa (aurkigarria)',
        inviteCode: 'Gonbidapen kodea',
        publish: 'Argitaratu', publishPlaceholder: 'Idatzi argitalpena…', visPrivate: 'Pribatua',
        visibility: 'Ikusgaitasuna',
        visPublic: 'Publikoa', visSubscribers: 'Harpidedunak',
        subscribers: 'harpidedun', code: 'Kodea', copyLink: 'Kopiatu esteka',
        leave: 'Irten kanaletik', delete: 'Ezabatu kanala',
        confirmLeave: 'Kanaletik irten?',
        confirmDelete: 'Kanala ezabatu? Ezin da desegin.',
        back: 'Atzera', close: 'Itxi', next: 'Hurrengoa', create: 'Sortu',
        attachImage: 'Irudia',
        onlyAdminsCanPost: 'Administratzaileek bakarrik argitara dezakete.',
        channelByLabel: 'en',
        contactMode: 'Kontaktua', contactNone: 'Ezer ez', contactDirect: 'Zuzeneko txata',
        contactForm: 'Inprimakia', contactBoth: 'Biak', useChannelDefault: 'Kanalaren lehenetsia',
        chatWithAdmin: 'Txateatu administratzailearekin', sendInquiry: 'Informazioa',
        inquiryTitle: 'Iragarkiari buruzko kontsulta', inquiryAd: 'Iragarkia',
        inquiryPhone: 'Telefonoa', inquiryName: 'Izena', inquiryMessage: 'Zure kontsulta',
        inquirySend: 'Bidali', inquirySent: 'Kontsulta bidalia'
    },
    fr: {
        title: 'Canaux', beta: 'Beta',
        categoryLabels: {
            food: '🍽️ Cuisine', tech: '💻 Tech', fashion: '👗 Mode',
            sports: '⚽ Sport', travel: '✈️ Voyages', art: '🎨 Art',
            music: '🎵 Musique', education: '📚 Éducation', health: '🏥 Santé',
            business: '💼 Affaires', entertainment: '🎬 Divertissement',
            news: '📰 Actualités', photography: '📸 Photographie', games: '🎮 Jeux',
            other: '🔖 Autre'
        },
        selectCategory: '-- Sélectionner catégorie --',
        tabHome: 'Nouveautés', tabList: 'Mes canaux',
        empty: "Vous ne suivez aucun canal.",
        emptyFeed: "Votre accueil est vide. Abonnez-vous à un canal.",
        noMessages: 'Aucun message.',
        loading: 'Chargement...',
        createBtn: 'Créer canal', subscribeBtn: 'Suivre',
        ownBadge: 'Ton canal', filterFollowing: 'Suivis', filterOwn: 'Mes canaux',
        emptyOwn: "Tu n'as pas encore publié de battements.",
        fameTitle: 'Battement de la Renommée', inviteFollowers: 'Inviter à suivre',
        chooseType: 'Quel type de canal ?',
        typePersonal: 'Personnel', typePersonalDesc: 'Amis, famille, privé',
        typeBusiness: 'Entreprise', typeBusinessDesc: 'Clients, boutique, marque',
        name: 'Nom', description: 'Description', category: 'Catégorie', bio: 'Bio',
        links: 'Liens (un par ligne)', isPublic: 'Canal public (découvrable)',
        inviteCode: "Code d'invitation",
        publish: 'Publier', publishPlaceholder: 'Écrire une publication…', visPrivate: 'Privé',
        visibility: 'Visibilité', visPublic: 'Public', visSubscribers: 'Abonnés',
        subscribers: 'abonnés', code: 'Code', copyLink: 'Copier lien',
        leave: 'Quitter', delete: 'Supprimer',
        confirmLeave: 'Quitter le canal ?', confirmDelete: 'Supprimer ? Action irréversible.',
        back: 'Retour', close: 'Fermer', next: 'Suivant', create: 'Créer',
        attachImage: 'Image',
        onlyAdminsCanPost: 'Seuls les admins publient.',
        channelByLabel: 'dans',
        contactMode: 'Contact', contactNone: 'Aucun', contactDirect: 'Chat direct',
        contactForm: 'Formulaire', contactBoth: 'Les deux', useChannelDefault: 'Par défaut',
        chatWithAdmin: "Chat avec l'admin", sendInquiry: 'Information',
        inquiryTitle: "Demande concernant l'annonce", inquiryAd: 'Annonce',
        inquiryPhone: 'Téléphone', inquiryName: 'Nom', inquiryMessage: 'Votre demande',
        inquirySend: 'Envoyer', inquirySent: 'Demande envoyée'
    },
    de: {
        title: 'Kanäle', beta: 'Beta',
        categoryLabels: {
            food: '🍽️ Essen', tech: '💻 Tech', fashion: '👗 Mode',
            sports: '⚽ Sport', travel: '✈️ Reisen', art: '🎨 Kunst',
            music: '🎵 Musik', education: '📚 Bildung', health: '🏥 Gesundheit',
            business: '💼 Geschäft', entertainment: '🎬 Unterhaltung',
            news: '📰 Nachrichten', photography: '📸 Fotografie', games: '🎮 Spiele',
            other: '🔖 Sonstiges'
        },
        selectCategory: '-- Kategorie wählen --',
        tabHome: 'Neuigkeiten', tabList: 'Meine Kanäle',
        empty: 'Du folgst keinem Kanal.', emptyFeed: 'Dein Start ist leer.',
        noMessages: 'Keine Nachrichten.', loading: 'Lädt...',
        createBtn: 'Kanal erstellen', subscribeBtn: 'Folgen',
        ownBadge: 'Dein Kanal', filterFollowing: 'Folge ich', filterOwn: 'Meine Kanäle',
        emptyOwn: 'Du hast noch keine Herzschläge veröffentlicht.',
        fameTitle: 'Herzschlag des Ruhms', inviteFollowers: 'Zum Folgen einladen',
        chooseType: 'Welcher Kanaltyp?',
        typePersonal: 'Persönlich', typePersonalDesc: 'Für Freunde und Familie',
        typeBusiness: 'Geschäft', typeBusinessDesc: 'Für Kunden und Marke',
        name: 'Name', description: 'Beschreibung', category: 'Kategorie', bio: 'Bio',
        links: 'Links (einer pro Zeile)', isPublic: 'Öffentlich (auffindbar)',
        inviteCode: 'Einladungscode',
        publish: 'Veröffentlichen', publishPlaceholder: 'Beitrag schreiben…', visPrivate: 'Privat',
        visibility: 'Sichtbarkeit', visPublic: 'Öffentlich', visSubscribers: 'Abonnenten',
        subscribers: 'Abonnenten', code: 'Code', copyLink: 'Link kopieren',
        leave: 'Verlassen', delete: 'Löschen',
        confirmLeave: 'Kanal verlassen?', confirmDelete: 'Löschen? Nicht umkehrbar.',
        back: 'Zurück', close: 'Schließen', next: 'Weiter', create: 'Erstellen',
        attachImage: 'Bild', onlyAdminsCanPost: 'Nur Admins posten.',
        channelByLabel: 'in',
        contactMode: 'Kontakt', contactNone: 'Keiner', contactDirect: 'Direktchat',
        contactForm: 'Formular', contactBoth: 'Beide', useChannelDefault: 'Kanal-Standard',
        chatWithAdmin: 'Chat mit Admin', sendInquiry: 'Information',
        inquiryTitle: 'Anfrage zur Ankündigung', inquiryAd: 'Ankündigung',
        inquiryPhone: 'Telefon', inquiryName: 'Name', inquiryMessage: 'Deine Anfrage',
        inquirySend: 'Senden', inquirySent: 'Anfrage gesendet'
    },
    pt: {
        title: 'Canais', beta: 'Beta',
        categoryLabels: {
            food: '🍽️ Comida', tech: '💻 Tecnologia', fashion: '👗 Moda',
            sports: '⚽ Esportes', travel: '✈️ Viagens', art: '🎨 Arte',
            music: '🎵 Música', education: '📚 Educação', health: '🏥 Saúde',
            business: '💼 Negócios', entertainment: '🎬 Entretenimento',
            news: '📰 Notícias', photography: '📸 Fotografia', games: '🎮 Jogos',
            other: '🔖 Outro'
        },
        selectCategory: '-- Selecionar categoria --',
        tabHome: 'Novidades', tabList: 'Meus canais',
        empty: 'Ainda não segue nenhum canal.',
        emptyFeed: 'Seu início está vazio.', noMessages: 'Sem mensagens.',
        loading: 'Carregando...',
        createBtn: 'Criar canal', subscribeBtn: 'Seguir',
        ownBadge: 'O teu canal', filterFollowing: 'A seguir', filterOwn: 'Meus canais',
        emptyOwn: 'Ainda não publicaste nenhum batimento.',
        fameTitle: 'Batimento da Fama', inviteFollowers: 'Convidar a seguir',
        chooseType: 'Que tipo de canal?',
        typePersonal: 'Pessoal', typePersonalDesc: 'Para amigos e família',
        typeBusiness: 'Negócio', typeBusinessDesc: 'Para clientes e marca',
        name: 'Nome', description: 'Descrição', category: 'Categoria', bio: 'Bio',
        links: 'Links (um por linha)', isPublic: 'Canal público (descobrível)',
        inviteCode: 'Código de convite',
        publish: 'Publicar', publishPlaceholder: 'Escreva uma publicação…', visPrivate: 'Privado',
        visibility: 'Visibilidade', visPublic: 'Público', visSubscribers: 'Inscritos',
        subscribers: 'inscritos', code: 'Código', copyLink: 'Copiar link',
        leave: 'Sair', delete: 'Excluir',
        confirmLeave: 'Sair do canal?', confirmDelete: 'Excluir? Ação irreversível.',
        back: 'Voltar', close: 'Fechar', next: 'Próximo', create: 'Criar',
        attachImage: 'Imagem', onlyAdminsCanPost: 'Apenas admins podem postar.',
        channelByLabel: 'em',
        contactMode: 'Contato', contactNone: 'Nenhum', contactDirect: 'Chat direto',
        contactForm: 'Formulário', contactBoth: 'Ambos', useChannelDefault: 'Padrão do canal',
        chatWithAdmin: 'Chat com admin', sendInquiry: 'Informação',
        inquiryTitle: 'Consulta sobre anúncio', inquiryAd: 'Anúncio',
        inquiryPhone: 'Telefone', inquiryName: 'Nome', inquiryMessage: 'Sua consulta',
        inquirySend: 'Enviar', inquirySent: 'Consulta enviada'
    },
    it: {
        title: 'Canali', beta: 'Beta',
        categoryLabels: {
            food: '🍽️ Cibo', tech: '💻 Tech', fashion: '👗 Moda',
            sports: '⚽ Sport', travel: '✈️ Viaggi', art: '🎨 Arte',
            music: '🎵 Musica', education: '📚 Istruzione', health: '🏥 Salute',
            business: '💼 Affari', entertainment: '🎬 Intrattenimento',
            news: '📰 Notizie', photography: '📸 Fotografia', games: '🎮 Giochi',
            other: '🔖 Altro'
        },
        selectCategory: '-- Seleziona categoria --',
        tabHome: 'Novità', tabList: 'I miei canali',
        empty: 'Non segui alcun canale.',
        emptyFeed: 'Home vuota. Iscriviti a un canale.',
        noMessages: 'Nessun messaggio.', loading: 'Caricamento...',
        createBtn: 'Crea canale', subscribeBtn: 'Segui',
        ownBadge: 'Il tuo canale', filterFollowing: 'Seguiti', filterOwn: 'I miei canali',
        emptyOwn: 'Non hai ancora pubblicato battiti.',
        fameTitle: 'Battito della Fama', inviteFollowers: 'Invita a seguire',
        chooseType: 'Che tipo di canale?',
        typePersonal: 'Personale', typePersonalDesc: 'Per amici e famiglia',
        typeBusiness: 'Affari', typeBusinessDesc: 'Per clienti e brand',
        name: 'Nome', description: 'Descrizione', category: 'Categoria', bio: 'Bio',
        links: 'Link (uno per riga)', isPublic: 'Pubblico (scopribile)',
        inviteCode: 'Codice invito',
        publish: 'Pubblica', publishPlaceholder: 'Scrivi una pubblicazione…', visPrivate: 'Privato',
        visibility: 'Visibilità', visPublic: 'Pubblico', visSubscribers: 'Iscritti',
        subscribers: 'iscritti', code: 'Codice', copyLink: 'Copia link',
        leave: 'Esci', delete: 'Elimina',
        confirmLeave: 'Uscire dal canale?', confirmDelete: 'Eliminare? Irreversibile.',
        back: 'Indietro', close: 'Chiudi', next: 'Avanti', create: 'Crea',
        attachImage: 'Immagine', onlyAdminsCanPost: 'Solo gli admin pubblicano.',
        channelByLabel: 'in',
        contactMode: 'Contatto', contactNone: 'Nessuno', contactDirect: 'Chat diretta',
        contactForm: 'Modulo', contactBoth: 'Entrambi', useChannelDefault: 'Predefinito',
        chatWithAdmin: "Chat con l'admin", sendInquiry: 'Informazione',
        inquiryTitle: "Richiesta sull'annuncio", inquiryAd: 'Annuncio',
        inquiryPhone: 'Telefono', inquiryName: 'Nome', inquiryMessage: 'La tua richiesta',
        inquirySend: 'Invia', inquirySent: 'Richiesta inviata'
    },
    zh: {
        title: '脉动', tabHome: '脉动', tabList: '我的脉动', empty: '还没有关注的脉动。',
        emptyFeed: '你的脉动是空的。订阅一个吧。', loading: '加载中...', noMessages: '没有消息。',
        createBtn: '创建脉动', subscribeBtn: '关注', chooseType: '什么类型的脉动？',
        typePersonal: '个人', typePersonalDesc: '朋友、家人和私人内容',
        typeBusiness: '商业', typeBusinessDesc: '客户、商店或品牌',
        name: '名称', description: '描述', category: '类别', bio: '简介', links: '链接',
        isPublic: '公开（可发现）', publish: '发布', publishPlaceholder: '添加你的脉动…',
        visibility: '可见性', visPublic: '公开', visPrivate: '私密', visSubscribers: '订阅者',
        subscribers: '订阅者', code: '代码', copyLink: '复制链接',
        leave: '退出', delete: '删除', confirmLeave: '退出？', confirmDelete: '删除？不可撤销。',
        back: '返回', close: '关闭', create: '创建', save: '保存', attachImage: '图片',
        onlyAdminsCanPost: '仅管理员可发布。', viewProfile: '查看资料',
        subscribeCta: '关注', alreadySubscribed: '已关注',
        ownBadge: '你的频道', filterFollowing: '关注中', filterOwn: '我的频道',
        emptyOwn: '你还没有发布任何脉动。',
        fameTitle: '名誉之心', inviteFollowers: '邀请关注',
        contactMode: '联系方式', contactNone: '无', contactDirect: '直接聊天',
        contactForm: '表单', contactBoth: '两者', chatWithAdmin: '联系管理员', sendInquiry: '信息',
        comments: '评论', commentsOn: '开启', commentsOff: '关闭', viewComments: '查看评论',
        addComment: '写评论...', sendComment: '发送', noComments: '暂无评论。', react: '反应',
        status: '状态', statusPlaceholder: '例如：营业中、休假中...',
        selectCategory: '-- 选择类别 --',
        categoryLabels: { food: '🍽️ 美食', tech: '💻 科技', fashion: '👗 时尚', sports: '⚽ 体育', travel: '✈️ 旅行', art: '🎨  艺术', music: '🎵 音乐', education: '📚 教育', health: '🏥 健康', business: '💼 商业', entertainment: '🎬 娱乐', news: '📰 新闻', photography: '📸 摄影', games: '🎮 游戏', other: '🔖 其他' }
    },
    ja: {
        title: 'パルス', tabHome: 'パルス', tabList: 'マイパルス', empty: 'まだフォローしていません。',
        emptyFeed: 'パルスは空です。フォローしましょう。', loading: '読込中...', noMessages: 'メッセージなし。',
        createBtn: 'パルス作成', subscribeBtn: 'フォロー', chooseType: 'どのタイプ？',
        typePersonal: '個人', typePersonalDesc: '友達・家族・プライベート',
        typeBusiness: 'ビジネス', typeBusinessDesc: '顧客・店舗・ブランド',
        name: '名前', description: '説明', category: 'カテゴリ', bio: '自己紹介', links: 'リンク',
        isPublic: '公開', publish: '投稿', publishPlaceholder: 'パルスを追加…',
        visibility: '公開範囲', visPublic: '公開', visPrivate: '非公開', visSubscribers: '登録者',
        subscribers: '登録者', code: 'コード', copyLink: 'リンクコピー',
        leave: '退出', delete: '削除', confirmLeave: '退出？', confirmDelete: '削除？元に戻せません。',
        back: '戻る', close: '閉じる', create: '作成', save: '保存', attachImage: '画像',
        onlyAdminsCanPost: '管理者のみ投稿可。', viewProfile: 'プロフィール',
        subscribeCta: 'フォロー', alreadySubscribed: 'フォロー中',
        ownBadge: 'あなたのチャンネル', filterFollowing: 'フォロー中', filterOwn: 'マイチャンネル',
        emptyOwn: 'まだパルスを投稿していません。',
        fameTitle: '名誉のハートビート', inviteFollowers: 'フォローに招待',
        contactMode: '連絡方法', contactNone: 'なし', contactDirect: 'チャット',
        contactForm: 'フォーム', contactBoth: '両方', chatWithAdmin: '管理者に連絡', sendInquiry: '情報',
        comments: 'コメント', commentsOn: 'オン', commentsOff: 'オフ', viewComments: 'コメント表示',
        addComment: 'コメントを書く...', sendComment: '送信', noComments: 'コメントなし。', react: 'リアクション',
        status: 'ステータス', statusPlaceholder: '例：営業中、休暇中...',
        selectCategory: '-- カテゴリ選択 --',
        categoryLabels: { food: '🍽️ グルメ', tech: '💻 テック', fashion: '👗 ファッション', sports: '⚽ スポーツ', travel: '✈️ 旅行', art: '🎨 アート', music: '🎵 音楽', education: '📚 教育', health: '🏥 健康', business: '💼 ビジネス', entertainment: '🎬 エンタメ', news: '📰 ニュース', photography: '📸 写真', games: '🎮 ゲーム', other: '🔖 その他' }
    },
    ar: {
        title: 'نبضات', tabHome: 'نبض', tabList: 'نبضاتي', empty: 'لم تتابع أي نبض بعد.',
        emptyFeed: 'نبضك فارغ. اشترك في واحد.', loading: 'جاري التحميل...', noMessages: 'لا رسائل.',
        createBtn: 'إنشاء نبض', subscribeBtn: 'متابعة', chooseType: 'أي نوع؟',
        typePersonal: 'شخصي', typePersonalDesc: 'أصدقاء وعائلة', typeBusiness: 'تجاري', typeBusinessDesc: 'عملاء وعلامة تجارية',
        name: 'الاسم', description: 'الوصف', category: 'الفئة', bio: 'نبذة', links: 'روابط',
        isPublic: 'عام', publish: 'نشر', publishPlaceholder: 'أضف نبضك…',
        visibility: 'الرؤية', visPublic: 'عام', visPrivate: 'خاص', visSubscribers: 'المشتركون',
        subscribers: 'مشتركون', code: 'رمز', copyLink: 'نسخ الرابط',
        leave: 'مغادرة', delete: 'حذف', back: 'رجوع', close: 'إغلاق', create: 'إنشاء', save: 'حفظ',
        attachImage: 'صورة', onlyAdminsCanPost: 'المسؤولون فقط.', viewProfile: 'الملف', subscribeCta: 'متابعة',
        ownBadge: 'قناتك', filterFollowing: 'المتابَعة', filterOwn: 'قنواتي',
        emptyOwn: 'لم تنشر أي نبضات بعد.',
        fameTitle: 'نبضة الشهرة', inviteFollowers: 'دعوة للمتابعة',
        contactMode: 'اتصال', contactNone: 'لا', contactDirect: 'محادثة', contactForm: 'نموذج', chatWithAdmin: 'تواصل', sendInquiry: 'معلومات',
        comments: 'تعليقات', commentsOn: 'مفعّل', commentsOff: 'معطّل', viewComments: 'التعليقات', addComment: 'اكتب تعليق...', noComments: 'لا تعليقات.'
    },
    hi: {
        title: 'धड़कन', tabHome: 'धड़कन', tabList: 'मेरी धड़कनें', empty: 'अभी कोई फॉलो नहीं।',
        emptyFeed: 'खाली है। किसी को फॉलो करें।', loading: 'लोड हो रहा...', noMessages: 'कोई संदेश नहीं।',
        createBtn: 'धड़कन बनाएं', subscribeBtn: 'फ़ॉलो', chooseType: 'किस प्रकार की?',
        typePersonal: 'व्यक्तिगत', typePersonalDesc: 'दोस्त और परिवार', typeBusiness: 'व्यापार', typeBusinessDesc: 'ग्राहक और ब्रांड',
        name: 'नाम', description: 'विवरण', category: 'श्रेणी', bio: 'परिचय', links: 'लिंक',
        isPublic: 'सार्वजनिक', publish: 'प्रकाशित', publishPlaceholder: 'अपनी धड़कन जोड़ें…',
        visibility: 'दृश्यता', visPublic: 'सार्वजनिक', visPrivate: 'निजी', subscribers: 'सदस्य',
        code: 'कोड', copyLink: 'लिंक कॉपी', leave: 'छोड़ें', delete: 'हटाएं', back: 'वापस', close: 'बंद', create: 'बनाएं', save: 'सेव',
        attachImage: 'छवि', onlyAdminsCanPost: 'केवल एडमिन।', viewProfile: 'प्रोफ़ाइल', subscribeCta: 'फ़ॉलो',
        ownBadge: 'तुम्हारा चैनल', filterFollowing: 'फॉलो कर रहे हैं', filterOwn: 'मेरे चैनल',
        emptyOwn: 'तुमने अभी तक कोई धड़कन पोस्ट नहीं की।',
        fameTitle: 'यश की धड़कन', inviteFollowers: 'फ़ॉलो के लिए आमंत्रित करें',
        contactMode: 'संपर्क', contactNone: 'कोई नहीं', contactDirect: 'चैट', contactForm: 'फ़ॉर्म', chatWithAdmin: 'एडमिन से चैट', sendInquiry: 'जानकारी',
        comments: 'टिप्पणियाँ', commentsOn: 'चालू', commentsOff: 'बंद', viewComments: 'टिप्पणियाँ देखें', addComment: 'टिप्पणी लिखें...', noComments: 'कोई टिप्पणी नहीं।'
    },
    ru: {
        title: 'Пульс', tabHome: 'Пульс', tabList: 'Мои пульсы', empty: 'Вы не подписаны.',
        emptyFeed: 'Пусто. Подпишитесь.', loading: 'Загрузка...', noMessages: 'Нет сообщений.',
        createBtn: 'Создать пульс', subscribeBtn: 'Подписаться', /* sigue siendo Follow en ruso */ chooseType: 'Какой тип?',
        typePersonal: 'Личный', typePersonalDesc: 'Друзья и семья', typeBusiness: 'Бизнес', typeBusinessDesc: 'Клиенты и бренд',
        name: 'Название', description: 'Описание', category: 'Категория', bio: 'О себе', links: 'Ссылки',
        isPublic: 'Публичный', publish: 'Опубликовать', publishPlaceholder: 'Добавьте пульс…',
        visibility: 'Видимость', visPublic: 'Публичный', visPrivate: 'Приватный', subscribers: 'подписчиков',
        code: 'Код', copyLink: 'Копировать', leave: 'Покинуть', delete: 'Удалить', back: 'Назад', close: 'Закрыть', create: 'Создать', save: 'Сохранить',
        attachImage: 'Изображение', onlyAdminsCanPost: 'Только админы.', viewProfile: 'Профиль', subscribeCta: 'Подписаться',
        ownBadge: 'Твой канал', filterFollowing: 'Подписки', filterOwn: 'Мои каналы',
        emptyOwn: 'Ты ещё не публиковал пульсов.',
        fameTitle: 'Пульс Славы', inviteFollowers: 'Пригласить подписаться',
        contactMode: 'Контакт', contactNone: 'Нет', contactDirect: 'Чат', contactForm: 'Форма', chatWithAdmin: 'Связаться', sendInquiry: 'Информация',
        comments: 'Комментарии', commentsOn: 'Вкл', commentsOff: 'Выкл', viewComments: 'Комментарии', addComment: 'Написать...', noComments: 'Нет комментариев.'
    },
    ko: {
        title: '맥박', tabHome: '맥박', tabList: '내 맥박', empty: '아직 팔로우한 것이 없습니다.',
        emptyFeed: '비어 있습니다. 구독하세요.', loading: '로딩...', noMessages: '메시지 없음.',
        createBtn: '맥박 만들기', subscribeBtn: '팔로우', chooseType: '어떤 유형?',
        typePersonal: '개인', typePersonalDesc: '친구와 가족', typeBusiness: '비즈니스', typeBusinessDesc: '고객과 브랜드',
        name: '이름', description: '설명', category: '카테고리', bio: '소개', links: '링크',
        isPublic: '공개', publish: '게시', publishPlaceholder: '맥박을 추가…',
        visibility: '공개범위', visPublic: '공개', visPrivate: '비공개', subscribers: '구독자',
        code: '코드', copyLink: '링크 복사', leave: '나가기', delete: '삭제', back: '뒤로', close: '닫기', create: '만들기', save: '저장',
        attachImage: '이미지', onlyAdminsCanPost: '관리자만 게시 가능.', viewProfile: '프로필', subscribeCta: '팔로우',
        ownBadge: '내 채널', filterFollowing: '팔로잉', filterOwn: '내 채널',
        emptyOwn: '아직 맥박을 게시하지 않았습니다.',
        fameTitle: '명예의 맥박', inviteFollowers: '팔로우 초대',
        contactMode: '연락', contactNone: '없음', contactDirect: '채팅', contactForm: '양식', chatWithAdmin: '관리자 연락', sendInquiry: '정보',
        comments: '댓글', commentsOn: '켜짐', commentsOff: '꺼짐', viewComments: '댓글 보기', addComment: '댓글 작성...', noComments: '댓글 없음.'
    },
    tr: {
        title: 'Nabız', tabHome: 'Nabız', tabList: 'Nabızlarım', empty: 'Henüz takip yok.',
        emptyFeed: 'Boş. Birine abone ol.', loading: 'Yükleniyor...', noMessages: 'Mesaj yok.',
        createBtn: 'Nabız oluştur', subscribeBtn: 'Takip et', chooseType: 'Hangi tür?',
        typePersonal: 'Kişisel', typePersonalDesc: 'Arkadaşlar ve aile', typeBusiness: 'İş', typeBusinessDesc: 'Müşteriler ve marka',
        name: 'Ad', description: 'Açıklama', category: 'Kategori', bio: 'Hakkında', links: 'Bağlantılar',
        isPublic: 'Herkese açık', publish: 'Yayınla', publishPlaceholder: 'Nabzını ekle…',
        visibility: 'Görünürlük', visPublic: 'Herkese açık', visPrivate: 'Gizli', subscribers: 'abone',
        code: 'Kod', copyLink: 'Bağlantı kopyala', leave: 'Ayrıl', delete: 'Sil', back: 'Geri', close: 'Kapat', create: 'Oluştur', save: 'Kaydet',
        attachImage: 'Resim', onlyAdminsCanPost: 'Sadece yöneticiler.', viewProfile: 'Profil', subscribeCta: 'Takip et',
        ownBadge: 'Kanalın', filterFollowing: 'Takip edilenler', filterOwn: 'Kanallarım',
        emptyOwn: 'Henüz hiç kalp atışı paylaşmadın.',
        fameTitle: 'Şöhretin Kalp Atışı', inviteFollowers: 'Takip etmeye davet et',
        contactMode: 'İletişim', contactNone: 'Yok', contactDirect: 'Sohbet', contactForm: 'Form', chatWithAdmin: 'Yöneticiyle iletişim', sendInquiry: 'Bilgi',
        comments: 'Yorumlar', commentsOn: 'Açık', commentsOff: 'Kapalı', viewComments: 'Yorumları gör', addComment: 'Yorum yaz...', noComments: 'Yorum yok.'
    },
    id: {
        title: 'Denyut', tabHome: 'Denyut', tabList: 'Denyut Saya', empty: 'Belum mengikuti.',
        emptyFeed: 'Kosong. Berlangganan.', loading: 'Memuat...', noMessages: 'Tidak ada pesan.',
        createBtn: 'Buat denyut', subscribeBtn: 'Ikuti', chooseType: 'Jenis apa?',
        typePersonal: 'Pribadi', typePersonalDesc: 'Teman dan keluarga', typeBusiness: 'Bisnis', typeBusinessDesc: 'Pelanggan dan merek',
        name: 'Nama', description: 'Deskripsi', category: 'Kategori', bio: 'Bio', links: 'Tautan',
        isPublic: 'Publik', publish: 'Terbitkan', publishPlaceholder: 'Tambahkan denyutmu…',
        visibility: 'Visibilitas', visPublic: 'Publik', visPrivate: 'Pribadi', subscribers: 'pelanggan',
        code: 'Kode', copyLink: 'Salin tautan', leave: 'Keluar', delete: 'Hapus', back: 'Kembali', close: 'Tutup', create: 'Buat', save: 'Simpan',
        attachImage: 'Gambar', onlyAdminsCanPost: 'Hanya admin.', viewProfile: 'Profil', subscribeCta: 'Ikuti',
        ownBadge: 'Saluranmu', filterFollowing: 'Mengikuti', filterOwn: 'Saluran saya',
        emptyOwn: 'Kamu belum memposting denyut apa pun.',
        fameTitle: 'Detak Ketenaran', inviteFollowers: 'Undang untuk mengikuti',
        contactMode: 'Kontak', contactNone: 'Tidak', contactDirect: 'Obrolan', contactForm: 'Formulir', chatWithAdmin: 'Hubungi admin', sendInquiry: 'Informasi',
        comments: 'Komentar', commentsOn: 'Aktif', commentsOff: 'Nonaktif', viewComments: 'Lihat komentar', addComment: 'Tulis komentar...', noComments: 'Tidak ada komentar.'
    }
};

const langMap = {
    'español': 'es', 'inglés': 'en', 'francés': 'fr', 'alemán': 'de',
    'portugués': 'pt', 'italiano': 'it', 'euskera': 'eu',
    'chino': 'zh', 'japonés': 'ja', 'árabe': 'ar', 'hindi': 'hi',
    'ruso': 'ru', 'coreano': 'ko', 'turco': 'tr', 'indonesio': 'id',
    'english': 'en', 'spanish': 'es', 'french': 'fr', 'german': 'de',
    'portuguese': 'pt', 'italian': 'it', 'basque': 'eu'
};

function current() {
    try {
        const user = JSON.parse(localStorage.getItem('kaixo_user'));
        const code = langMap[user?.language?.toLowerCase()];
        return dict[code] || dict.en;
    } catch { return dict.en; }
}

// Proxy reactivo con fallback a inglés si una clave falta en el idioma actual.
const ct = new Proxy({}, {
    get(_t, prop) {
        const c = current();
        const v = c[prop];
        if (v !== undefined) return v;
        return dict.en[prop];
    }
});

export default ct;
